interface IGetNumberByAddressOptions {
  defaultValue?: string;
}

function getNumberByAddress(
  value?: string | null,
  options?: IGetNumberByAddressOptions,
): string {
  if (!value) {
    return options?.defaultValue || '';
  }

  const regexGetAllAfterNumber = /[ ]+(?=[0-9])/g;

  const number = value.split(regexGetAllAfterNumber)[1];

  return number;
}

export default getNumberByAddress;
